exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n\r\n::-webkit-input-placeholder {\r\n  color: #f0ad4e !important;\r\n  text-transform: none;\r\n}\r\n\r\n:-moz-placeholder { /* Firefox 18- */\r\n  color: #f0ad4e !important;\r\n  text-transform: none;\r\n}\r\n\r\n::-moz-placeholder { /* Firefox 19+ */\r\n  color: #f0ad4e !important;\r\n  text-transform: none;\r\n}\r\n\r\n:-ms-input-placeholder {\r\n  color: #f0ad4e !important;\r\n  text-transform: none;\r\n}\r\n\r\n.container {\r\n  margin-top: 40px;\r\n}\r\n\r\n.jumbotron {\r\n  background-color: #EFEBE9;\r\n}\r\n\r\ninput {\r\n  border-color: #f0ad4e;\r\n  color: #8a6d3b !important;\r\n  text-transform: uppercase;\r\n}\r\n\r\ninput:focus {\r\n  border-color: #f0ad4e;\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/help/busca/busca.component.css
// module id = 169
// module chunks = 1